import { post, put, get } from "../fetch.v2"
import { IEmployeeCreate } from "../../interfaces/employee"
import { getDomainId } from "../../utils/store"
import { getEventId } from "../helper"

class EmployeeApi {
  url: string

  constructor(eventId?: number) {
    const domainId = getDomainId()
    this.url = eventId
      ? `/domains/${domainId}/events/${eventId}`
      : `/domains/${domainId}`
  }

  async getAllByUserId(userId: number) {
    return get(`${this.url}/users/${userId}/companies`)
  }

  async getAllByCompanyId(companyId: number) {
    return get(`${this.url}/companies/${companyId}/users`)
  }

  async getAssociatesWithParticipation(userId: number) {
    return get(`${this.url}/users/${userId}/companies/associates`)
  }

  async createOne(userId: number, companyId: number) {
    return post(`${this.url}/users/${userId}/companies/${companyId}`)
  }

  async updateOne(
    userId: number,
    companyId: number,
    employee: Partial<IEmployeeCreate>
  ) {
    return put(`${this.url}/users/${userId}/companies/${companyId}`, employee)
  }

  async archiveOne(userId: number, companyId: number) {
    return put(`${this.url}/users/${userId}/companies/${companyId}/archive`)
  }

  async primaryOne(userId: number, companyId: number) {
    return put(`${this.url}/users/${userId}/companies/${companyId}/primary`)
  }

  async getFunctions() {
    return get(`${this.url}/employees/functions`)
  }
}

export default EmployeeApi
